function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenzinga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 197.28,
    height: 26.61,
    viewBox: "0 0 197.28 26.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M444.88,534.14h18.94v-4.95H450.6v-6.07h10.95v-5H450.6v-5.61h13.28v-5h-19Zm41.72-9.85-12.39-16.7h-8.55l2.66,3.36v23.26H474V516.79l12.83,17.35h5.46V507.59H486.6Zm-50.37-3.81a6,6,0,0,0,4.61-6.07c0-3.52-2.6-6.82-7.76-6.82H416.47l2.57,3.27v23.28h14.59c5.17,0,7.83-3.19,7.83-7.2C441.39,523.67,439.13,520.87,436.23,520.48Zm-11.44-7.9H432c1.94,0,3.15,1.11,3.15,2.81s-1.21,2.8-3.15,2.8h-7.17Zm7.43,16.64h-7.4v-6.1h7.4a3.06,3.06,0,0,1,3.39,3c0,1.93-1.29,3-3.39,3.07Zm143.85-4.93h3v3.13a8.76,8.76,0,0,1-5.49,2c-4.77,0-8.15-3.58-8.15-8.48s3.38-8.48,8.15-8.48a7.34,7.34,0,0,1,6.12,3.36l4.5-2.48a12.16,12.16,0,0,0-10.72-5.74c-7.56,0-13.87,5.19-13.87,13.28s6.21,13.27,13.87,13.27a14.36,14.36,0,0,0,10.95-4.79v-9.82h-12.2Zm-25.78,0-12.43-16.7h-8.54L532,511v23.26h5.72V516.79l12.82,17.35H556V507.59h-5.72v16.7Zm53.1-16.7h-11L595,511l-.49,1.28-8.55,22h6.44l1.68-4.47h11.54l1.68,4.47h6.44Zm-7.79,17.13,4.18-11.45L604,524.72Zm-75.29-17.13H526v26.62h-5.72Zm-4.61,4.57v-4.57H495.55v5h12.66l-12.66,17v4.56h20.38v-4.95H503Z",
    transform: "translate(-416.47 -507.59)",
    style: {
      fill: "#343838"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenzinga);
export default __webpack_public_path__ + "static/media/BENZINGA.c59df62cb3432b5f1b45d8b12fca9ee1.svg";
export { ForwardRef as ReactComponent };